import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import styles from '@features/productPreview/sections/Banners/Banners.styles';
import { ISlide } from '@features/productPreview/typescript/index';
import { WindowType } from '@typescript/index';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  items: {
    slides: ISlide[];
  }[];
  hrefPrefix: string;
  windowType: WindowType;
  variant?: 'productCard' | 'cart';
};
const Banners = ({
  items,
  hrefPrefix,
  windowType,
  variant = 'productCard'
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const isMobile = windowType === WindowType.mobile;
  const isTablet = windowType === WindowType.tablet;
  const getImgSrc = (slide: ISlide) => {
    if (isTablet && slide?.tablet) return slide.tablet;
    if (isMobile && slide?.mobile) return slide.mobile;
    return slide?.desktop || '';
  };
  const getSize = () => {
    if (isTablet) return {
      width: 786,
      height: 308
    };
    if (isMobile) return {
      width: 375,
      height: 510
    };
    return {
      width: 1920,
      height: 386
    };
  };
  const getLink = (slide: ISlide): string | null => {
    let link: string | null = null;
    if (slide?.href) {
      link = hrefPrefix + slide?.href;
    }
    return link;
  };
  return items.length > 0 ? <section sx={styles.section(variant)}>
      {items.map(item => item.slides.map((slide, slideIndex) => {
      const bannerAlt = t('accessibility.promotionBanner', {
        index: slideIndex + 1
      });
      return getLink(slide) ? <Link key={`${slide.id}-${Math.random()}`} href={getLink(slide) || '#'}>
              <div sx={styles.container(getSize(), variant)}>
                <ResponsiveImage image={getImgSrc(slide)} width={getSize().width} height={getSize().height} alt={bannerAlt} />
              </div>
            </Link> : <div key={`${slide.id}-${Math.random()}`} sx={styles.container(getSize(), variant)}>
              <ResponsiveImage image={getImgSrc(slide)} width={getSize().width} height={getSize().height} alt={bannerAlt} />
            </div>;
    }))}
    </section> : <></>;
};
export default Banners;